import createReactComponent from '../createReactComponent';
export default createReactComponent('cube-unfolded', 'IconCubeUnfolded', [
  ['path', { d: 'M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5z', key: 'svg-0' }],
  ['path', { d: 'M7 15v-5h5v5h5v-5', key: 'svg-1' }],
]);
